<div class="min-h-screen bg-gray-50 dark:bg-gray-900">
  <div class="mx-auto px-4 sm:px-4 lg:px-4 py-4">
    <div class="mb-4">
    <!-- Valuation Calculators Section -->
    <div class="text-left mb-8" *ngIf="showValuationSection()">
      <div class=" mx-auto bg-gradient-to-r from-green-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 rounded-xl p-8 border border-green-200 dark:border-gray-600">
        <p class="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
          Every stock tell a different story, so we give yuh more than one way fi measure di price.
          Use <span class="font-semibold text-green-600">Bad Man Forward</span> for growth companies,
          <span class="font-semibold text-yellow-600">Money A Run</span> for free cashflow-rich companies,
          <span class="font-semibold text-orange-600">Big Up Yield</span> for steady earners that bring in profits, and
          <span class="font-semibold text-red-600">Graham Remix</span> for a modern twist on Benjamin Graham's classic formula.
          Find the fair price, di Yardie way.
        </p>
        <div class="flex justify-start mb-2 mt-2">
          <button
            (click)="toggleValuationSection()"
            class="text-grey-500 hover:text-gray-700 dark:text-yellow-400 dark:hover:text-gray-200 transition-colors duration-200"
            type="button"
            aria-label="Hide valuation section">
            <i class="fas fa-close"> </i>Hide
          </button>
        </div>
      </div>
    </div>

    <!-- Show Valuation Section Button (when hidden) -->
    <div class="text-left mb-1" *ngIf="!showValuationSection()">
      <button
        (click)="toggleValuationSection()"
        class="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 hover:from-green-100 hover:to-blue-100 dark:hover:from-gray-700 dark:hover:to-gray-600 text-gray-700 dark:text-gray-300 rounded-lg border border-green-200 dark:border-gray-600 transition-all duration-200 shadow-sm hover:shadow-md"
        type="button">
        <i class="fas fa-info-circle"></i></button>
    </div>
    <!-- Calculator Tabs -->
    <div class="mb-4">
      <div class="border-b border-gray-200 dark:border-gray-700">
        <nav class="tab-navigation -mb-px overflow-x-auto" aria-label="Calculator Tabs">
          <button
            *ngFor="let tab of calculatorTabs(); trackBy: trackByRoute"
            (click)="navigateToTab(tab.route)"
            [class]="isActive(tab.route)
              ? 'tab-button tab-active whitespace-nowrap py-2 px-3 border-b-2 font-medium text-sm border-green-500 text-green-600 dark:text-green-400'
              : 'tab-button whitespace-nowrap py-2 px-3 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'"
            type="button">
            {{ tab.label }}
          </button>
        </nav>
      </div>
    </div>

    <!-- Tab Description Header -->
    <div class="mb-6" *ngIf="activeTabDetails()">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
          {{ activeTabDetails()?.label }}
        </h2>
        <p class="text-gray-600 dark:text-gray-300">
          {{ activeTabDetails()?.description }}
        </p>
      </div>
    </div>

    <!-- Shared Stock Search and Selected Company Display -->
    <div class="mb-6">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <!-- Search Section -->
          <div>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Search for a Company
            </h3>
            <app-stock-search (appStockSelected)="onCompanySelected($event)"></app-stock-search>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">
              Select a company to automatically populate calculator fields with TTM data
            </p>
          </div>

          <!-- Selected Company Display -->
          <div *ngIf="ttmData() && ttmData()?.ticker" class="flex items-center">
            <div class="w-full bg-gradient-to-r from-green-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 rounded-lg p-4 border-l-4 border-green-500">
              <div class="flex items-center justify-between flex-wrap gap-4">
                <div class="flex items-center gap-3">
                  <!-- Company Logo or Icon -->
                  <div class="flex items-center justify-center w-12 h-12 bg-white dark:bg-gray-900 rounded-full overflow-hidden border-2 border-green-500">
                    <img *ngIf="ttmData()?.logoUrl" 
                         [src]="ttmData()?.logoUrl" 
                         [alt]="ttmData()?.ticker + ' logo'"
                         class="w-full h-full object-cover"
                         (error)="onLogoError($event)">
                    <i *ngIf="!ttmData()?.logoUrl || logoError" 
                       class="fas fa-chart-line text-green-500 text-xl"></i>
                  </div>
                  <div>
                    <h4 class="text-base font-bold text-gray-900 dark:text-white">
                      {{ ttmData()?.ticker }}
                    </h4>
                    <p class="text-xs text-gray-600 dark:text-gray-300">
                      {{ selectedCompanyName() }}
                    </p>
                  </div>
                </div>
                <div class="text-right" *ngIf="ttmData()?.currentPrice">
                  <p class="text-xs text-gray-500 dark:text-gray-400">Current Price</p>
                  <p class="text-xl font-bold text-green-600 dark:text-green-400">
                    ${{ ttmData()?.currentPrice?.toFixed(2) }}
                  </p>
                </div>
              </div>
              
              <!-- Action Buttons -->
              <div class="flex items-center gap-2 mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                <button 
                  (click)="refreshTtmData()"
                  [disabled]="isLoadingTtmData()"
                  class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  type="button"
                  title="Refresh TTM data">
                  <i class="fas fa-sync-alt mr-1.5" [class.animate-spin]="isLoadingTtmData()"></i>
                  Refresh
                </button>
                <button 
                  (click)="clearCalculatorData()"
                  [disabled]="isLoadingTtmData()"
                  class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md text-gray-700 bg-white dark:text-gray-200 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  type="button"
                  title="Clear calculator data">
                  <i class="fas fa-times mr-1.5"></i>
                  Clear
                </button>
              </div>
              
              <div *ngIf="isLoadingTtmData()" class="flex items-center gap-2 mt-2">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-green-500"></div>
                <span class="text-xs text-gray-500 dark:text-gray-400">Loading data...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Content -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
